import ACTIONS from '../actions.js'

export function authReducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET_AUTH_TYPE:
      return {
        ...state,
        authType: action.value,
        password: '',
        prompt: '',
        userId: null,
        selectedQuestion: action.value === 'secret-question' ? 'dssn' : '',
      }

    case ACTIONS.SET_SECRET_QUESTIONS:
      return {
        ...state,
        secretQuestions: action.value,
      }

    case ACTIONS.UPDATE_SECRET_QUESTION: {
      const { questionKey, field, value } = action.payload
      return {
        ...state,
        secretQuestions: {
          ...state.secretQuestions,
          [questionKey]: {
            ...state.secretQuestions[questionKey],
            [field]: value,
          },
        },
      }
    }

    default:
      return state
  }
}

export default authReducer
